export function prepareExplanationOptions(description?: string): string[][] {
  if (description == null || description.length === 0) {
    return []
  }

  return description
    .split('\n')
    .map((i) => i.trim().slice(2)) // delete whitespaces and first dash
    .filter((i) => i.length !== 0)
    .map((i) => i.replace(/\(кл. (\d\d)\)/g, '___$$$1___').split('___'))
}
